/*!
 * MLE.Client.Components.Error.Notfound
 * File: notfound.error.js
 * Copyright (c) 2025 Runtime Software Development Inc.
 * Version 2.1
 * MIT Licensed
 */

import React from "react";

const NotfoundError = () => {
    return (
        <div>
            <p>Loading requested page...</p>
        </div>
    );
}

export default NotfoundError;
